import React, { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  NavIcon,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  NavItemBtn,
} from "./Navbar.elments";
import logo from "../../images/logoPersonal.png";
import { BsFillSunFill, BsFillMoonFill } from "react-icons/bs";
import Switch from "react-switch";

export default function Navbar({ light, setlight }) {
  const [click, setClick] = useState(false);
  const [moved, setmoved] = useState(false);

  const handleClick = () => {
    setClick(!click);
  };

  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
      setmoved(true);
    } else {
      setmoved(false);
    }
  });

  useEffect(() => {
    //Indicador de menú(ScrollSpy)
    const secciones = document.querySelectorAll(".seccion");
    const menuItems = document.querySelectorAll(".menu_item");

    const seccionesR = document.querySelectorAll(".resume");
    const menuItemsR = document.querySelectorAll(".nav_item");

    window.onscroll = () => {
      if (window.innerWidth > 960) {
        secciones.forEach((sec) => {
          let top = window.scrollY;
          let offset = sec.offsetTop;
          let margen = offset - 100;
          let height = sec.offsetHeight;
          let id = sec.getAttribute("id");

          if (top >= margen && top < offset + height) {
            menuItems.forEach((link) => {
              const a = link.children[0];
              link.classList.remove("active");
              a.classList.remove("active");
              if (a.children[0]) {
                const button = a.children[0];
                button.classList.remove("active");
              }

              if (link.dataset.url === id) {
                link.classList.add("active");
                a.classList.add("active");
                if (a.children[0]) {
                  const button = a.children[0];
                  button.classList.add("active");
                }
              }
            });
          }
        });

        seccionesR.forEach((sec) => {
          let top = window.scrollY;
          let offset = sec.offsetTop;
          let margen = offset - 50;
          let height = sec.offsetHeight;
          let id = sec.getAttribute("id");

          if (top >= margen && top < offset + height) {
            menuItemsR.forEach((link) => {
              const a = link.children[0];
              a.classList.remove("active");
              if (link.dataset.url === id) {
                a.classList.add("active");
              }
            });
          }
        });
      }
    };
  }, []);

  const changeTheme = () => {
    setlight(!light);
  };

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav light={light} moved={moved}>
          <NavbarContainer>
            <NavLogo light={light} href="home">
              <NavIcon src={logo} light={light} />
              Alonso Díaz Sobrino
            </NavLogo>
            <MobileIcon light={light} onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </MobileIcon>
            <NavMenu onClick={handleClick} click={click} light={light}>
              <NavItem
                data-url="home"
                className="menu_item active"
                light={light}
              >
                <NavLinks light={light} href="#home">
                  Inicio
                </NavLinks>
              </NavItem>
              <NavItem data-url="aboutme" className="menu_item" light={light}>
                <NavLinks light={light} href="#aboutme">
                  Sobre mí
                </NavLinks>
              </NavItem>
              <NavItem data-url="formacion" className="menu_item" light={light}>
                <NavLinks light={light} href="#formacion">
                  Formación
                </NavLinks>
              </NavItem>
              <NavItem data-url="skills" className="menu_item" light={light}>
                <NavLinks light={light} href="#skills">
                  Habilidades
                </NavLinks>
              </NavItem>
              <NavItem data-url="projects" className="menu_item" light={light}>
                <NavLinks light={light} href="#projects">
                  Proyectos
                </NavLinks>
              </NavItem>
              <NavItem data-url="contactme" className="menu_item" light={light}>
                <NavLinks light={light} href="#contactme">
                  Contacto
                </NavLinks>
              </NavItem>

              <NavItemBtn onClick={changeTheme}>
                <Switch
                  className="switch"
                  onChange={changeTheme}
                  checked={light}
                  checkedIcon={<BsFillSunFill />}
                  uncheckedIcon={<BsFillMoonFill />}
                  onHandleColor="#ebe1c9"
                  offHandleColor="#5dc1b9"
                  onColor="#9c9c9c"
                />
              </NavItemBtn>
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
}
